import { delay, put, select } from 'redux-saga/effects';
import { selectNotifications, setNotifications } from './notificationsSlice';

function* notificationSaga() {
    while (true) {
        yield delay(500);
        const notifications = yield select(selectNotifications);
        const now = new Date().getTime();
        let shouldUpdate = false;
        const updatedNotifications = notifications.map(n => {
            const diffInMilliseconds = now - n.lastInteractionAt;
            if (!n.focused && diffInMilliseconds > 3 * 1000) {
                shouldUpdate = true;
                return { ...n, open: false };
            }
            return { ...n };
        });
        if (shouldUpdate) {
            yield put(setNotifications(updatedNotifications));
        }
    }
}

export default notificationSaga;
